import { useState, type ReactNode } from 'react';
import FadeIn from './FadeIn';

/**
 * Lets values the plan withheld fade in once they are unlocked, instead of
 * popping in. Only a change from locked to open in this mount plays; a value
 * that was never locked renders as it is. Reduced motion is FadeIn's.
 */
export const RevealOnUnlock = ({
  locked,
  delay = 0,
  children,
}: {
  locked: boolean;
  /** Seconds, to stagger several values revealed by the same unlock. */
  delay?: number;
  children: ReactNode;
}) => {
  const [previous, setPrevious] = useState(locked);
  const [revealed, setRevealed] = useState(false);
  if (previous !== locked) {
    setPrevious(locked);
    if (previous && !locked) setRevealed(true);
  }

  if (!revealed) return <>{children}</>;
  return (
    <FadeIn delay={delay} duration={0.2} y={4}>
      {children}
    </FadeIn>
  );
};
